module.exports = __webpack_public_path__ + "media/activity-level/normal-leisurely-cbd1eea5.svg";